// extracted by mini-css-extract-plugin
module.exports = {"table-container":"Table_table-container__24FoY","loadMoreButtonContainer":"Table_loadMoreButtonContainer__QK5pG"};